// Ionic & Angular Imports
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/observable';
import 'rxjs/add/operator/map';

// Interfaces
export interface EquipmentType {
    id: number;
    name: string;
    description: string;
    picture: boolean;
}

@Injectable()
export class rsEquipmentTypeSvc {

    constructor( private http: Http ) 
    {
        
    }
    getEquipmentTypes( filter: string = "visible" ) : Observable<EquipmentType[]> {
        // Return our observable
        return Observable.create( observer => {
            // This method gets run when an object subscribes
            this.http.get( 'http://dfr.hydrocon.com/api/v1/equipmenttype/filters/' + filter, {
                withCredentials: true
            })
            .map( res => {
                return res.json().response.equipmenttype;
            })
            .subscribe( result => {
                // operation successful
                observer.next(result);
            }, err=> {
                // error encountered
                observer.error(err);
            }, () => {
                // operation complete
                observer.complete();
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/equipmenttype.service.ts